import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { UtilsService } from 'src/app/shared/utils.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RbacRolesEditComponent } from '../rbac-roles-edit/rbac-roles-edit.component';
import { RBACService } from '../../../shared/rbac.service';

@Component({
  selector: 'app-rbac-roles-tabs',
  templateUrl: './rbac-roles-tabs.component.html',
  styleUrls: ['./rbac-roles-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RbacRolesTabsComponent implements OnInit {
  // Reference to the edit component for calling save from dialog actions.
  @ViewChild('editComponent') editComponent: RbacRolesEditComponent;

  // The RBAC role id.
  rbac_role_id: number;

  // Track the selected tab index to show/hide dialog actions.
  selectedTabIndex: number = 0;

  // RBAC permission flag. Resolved once in ngOnInit() so the template does not
  // re-evaluate the permission check on every change detection cycle.
  //
  // Role membership is a sub-operation of the RBAC roles feature, so it is gated by the parent
  // feature's own view permission. employees:view is deliberately NOT required: a user who can
  // administer RBAC roles can grant themselves any permission from this same dialog, so requiring
  // it added friction without creating a security boundary.
  canViewMembers: boolean = false;

  constructor(
    public utils: UtilsService,
    public rbac: RBACService,
    private dialogRef: MatDialogRef<RbacRolesTabsComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: any
  ) {}

  protected readonly RBACService = RBACService;

  ngOnInit(): void {
    // Resolve RBAC permission flags.
    this.canViewMembers = this.rbac.userCanAccess(
      [
        RBACService.getPermission(
          RBACService.RBAC_F.F_ACCOUNT_RBAC_ROLES,
          RBACService.RBAC_A.A_VIEW
        )
      ],
      true
    );

    // Get the RBAC role id.
    this.rbac_role_id = Number(this.dialogData['rbac_role_id']);
  }

  /**
   * Close the dialog.
   */
  onClose(): void {
    this.dialogRef.close();
  }
}
